import { render, staticRenderFns } from "./CourseBuyMobile.vue?vue&type=template&id=6a31ca25&scoped=true"
import script from "./CourseBuyMobile.vue?vue&type=script&lang=js"
export * from "./CourseBuyMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a31ca25",
  null
  
)

export default component.exports